export default {
    data() {
      return {
        dashboard: null,
        groups: [],
        groupsKey: 0,
        isLoading: true,
        time: '',
        timeUpdateInterval: null,
        reloadVariableDataInterval: null,
        dataValues: [],
        service: null,
        measurerService: null,
        dashboardDisplayService: null,
        dataService: null,
      };
    },
    methods: {
      getVariableData() {
        this.dataService.filterByDashboardId(this.id).then((res) => { this.dataValues = res; });
      },
    },
    async mounted() {
  
      this.service = new this.$dashboardService();
      this.measurerService = new this.$measurerService();
      this.dataService = new this.$dataService();
      
      this.getVariableData();
      this.reloadVariableDataInterval = setInterval(this.getVariableData, 1000);

    },
    beforeDestroy() {
      clearInterval(this.reloadVariableDataInterval);
    },
  };
  